import { useState, useEffect, useContext } from "react";
import { DatabaseValue } from "../contexts/database";
import Dynamic from "../editors/dynamic";
import { MdDelete } from "react-icons/md";

export default function SetData({ value, onChange, params, sources }) {
  const database = useContext(DatabaseValue);
  const [fields, setFields] = useState(null);
  const [_value, setValue] = useState({});

  useEffect(() => {
    try {
      const fields = { ...database.find((x) => x.id === params.type).fields };
      Object.keys(fields).forEach((k) => {
        if (!fields[k].editable) {
          delete fields[k];
        }
      });
      setFields(fields);
    } catch (err) {
      console.log(err);
    }
  }, [params, database]);

  useEffect(() => {
    if (value) {
      setValue(value);
    }
  }, [value]);

  const addField = (k) => {
    const newValue = { ..._value };
    if (fields[k].type === "Text" && fields[k].list === false) {
      newValue[k] = [""];
    } else {
      newValue[k] = [{}];
    }
    setValue(newValue);
  };

  const handleChange = (value, key) => {
    const newValue = { ..._value };
    newValue[key] = value;
    setValue(newValue);
    onChange(newValue);
  };

  const handleDelete = (key) => {
    const newValue = { ..._value };
    delete newValue[key];
    setValue(newValue);
    onChange(newValue);
  };

  if (!fields) {
    return null;
  }
  return (
    <div style={{ border: "1px solid var(--main-border-color", padding: 6 }}>
      {Object.keys(_value).map((k) => {
        return (
          <DataRow
            key={k}
            sources={sources}
            onChange={(v) => handleChange(v, k)}
            id={k}
            field={fields[k]}
            value={_value[k]}
            onDelete={() => handleDelete(k)}
          ></DataRow>
        );
      })}
      <div style={{ fontSize: 12 }}>Add Field</div>
      <select
        value=""
        onChange={(e) => addField(e.target.value)}
        className="dropdown"
      >
        <option value="">select field...</option>
        {Object.keys(fields)
          .filter((x) => !_value[x])
          .map((k) => {
            return (
              <option key={k} value={k}>
                {fields[k].name}
              </option>
            );
          })}
      </select>
    </div>
  );
}

const DataRow = ({ id, field, value, onChange, onDelete, sources }) => {
  const handleChange = (v) => {
    onChange(v);
  };
  return (
    <div style={{ display: "flex", flexDirection: "column", marginBottom: 8 }}>
      <div style={{ fontSize: 12 }}>{field.name}</div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ flexGrow: 1 }}>
          <Dynamic
            value={value}
            onChange={handleChange}
            sources={sources}
            params={{ type: field.type, list: field.list }}
          />
        </div>
        <MdDelete onClick={onDelete} />
      </div>
    </div>
  );
};
